import addFormats from 'ajv-formats';
import type { Options } from 'ajv';
import Ajv from 'ajv';

/**
 * Default options used by Fastify.
 */
const defaultOptions = {
  coerceTypes: true,
  useDefaults: true,
  removeAdditional: true,
  // Note: When set to `true`, a DoS attack is possible.
  allErrors: false,
};

/**
 * Creates a new validator instance with additional data types
 * @param options Options for validator
 * @returns A validator instance
 */
export const createValidatorInstance = (options: Options = defaultOptions) =>
  addFormats(new Ajv({ ...options, $data: true }), {
    keywords: true,
    formats: [
      'date-time',
      'time',
      'date',
      'email',
      'hostname',
      'ipv4',
      'ipv6',
      'uri',
      'uri-reference',
      'uuid',
      'uri-template',
      'json-pointer',
      'relative-json-pointer',
      'regex',
    ],
  });
